import { render, staticRenderFns } from "./InjuryForm.vue?vue&type=template&id=4806a027&scoped=true"
import script from "./InjuryForm.vue?vue&type=script&lang=js"
export * from "./InjuryForm.vue?vue&type=script&lang=js"
import style0 from "./InjuryForm.vue?vue&type=style&index=0&id=4806a027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4806a027",
  null
  
)

export default component.exports